<template>
	<div>
		<page-header :title="title"></page-header>
		<form @submit.prevent="gravar">
			<div class="modal-body">
				<div class="form-horizontal">
					<vue-element-loading :active="isActive" spinner="bar-fade-scale"
						color="#428BCA"></vue-element-loading>
					<input-form-text textInput="Título" :required="true" v-model="form.titulo"
						:value="form.titulo"></input-form-text>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="descricao"> Descrição</label>
						<div class="col-sm-6">
							<textarea class="form-control" v-model="form.descricao" placeholder="Descrição" v-autosize></textarea>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right">Imagem</label>
						<div class="col-sm-5">
							<items-edit v-if="allImages.length" :files="allImages" url="/v1/etapas/upload" :capa="true" id="id" :isDrag="true" urlSort="/v1/etapas/order/" idSort="id"></items-edit>
							<file-upload ref="fupload" :url="`/v1/etapas/upload`" :id="null" :label="'PNG, JPG, GIF até 10 MB'"  width="800"></file-upload>
						</div>
					</div>
					<input-form-text textInput="URL" v-model="form.url"
						:value="form.url"></input-form-text>
					<div class="form-group">
						<select-form v-model="form.ativo" :value="form.ativo" name="Ativo" url="/arquivos" id="id"
							titulo="nome" layout="true" optionText="Selecione" required="true"></select-form>
					</div>
				</div>
			</div>
			<footer-button :disabled="isActiveBtn"></footer-button>
		</form>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'
import fileUpload from '@/components/form/file-upload/Index'
import ItemsEdit from '@/components/form/file-upload/ItemsEdit'

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
		fileUpload,
		ItemsEdit,
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Linha do Tempo',
			form: {
				titulo: '',
				descricao: '',
				url: '',
				ativo: '1',
			},
			allImages: [],
			isActiveBtn: false,
			isActive: false
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		async gravar() {
			this.isActive = true
			this.isActiveBtn = true
			const body = this.form
			//this.setVersion()
			if (this.$route.params.id) {
				let resp = await req(`/v1/etapas/${this.$route.params.id}`, 'put', body).catch(() => {
					erro()
				})
				this.isActive = false
				const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
				const m = tb[0]
				await m.uploadAll(resp)
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/linha-do-tempo')
			} else {
				let resp = await req('/v1/etapas', 'post', body).catch(() => {
					erro()
				})
				this.isActive = false
				const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
				const m = tb[0]
				await m.uploadAll(resp)
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/site/linha-do-tempo')
			}
			this.isActiveBtn = false
		},
		async setVersion() {
			await req('/versao/1', 'put', {
				title: Date.now()
			})
		},
		async getDadosImagens() {
			const resp = await req(`/v1/etapas/images/${this.$route.params.id}`).catch(() => {
				erro()
			})
			this.allImages = resp
		},
		getDados() {
			req(`/v1/etapas/${this.$route.params.id}`).then(resp => {
				this.form.ativo = resp.ativo
				this.form.titulo = resp.titulo
				this.form.descricao = resp.descricao
				this.form.url = resp.url
				this.isActive = false
			}).catch(() => {
				erro()
			})
		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	mounted() {
		this.verifPermissao()
		if (this.$route.params.id) {
			this.isActive = true
			Promise.all([this.getDados(), this.getDadosImagens()])
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
